import { useIsFromApp } from '../../Hooks/useIsInIframe';
import { useOrganisationData } from '../../Hooks/useOrganisation';

export default function useIsAppEnabled() {
  const isFromApp = useIsFromApp();
  const organisation = useOrganisationData();
  return isFromApp && !!organisation.features.cogneedAi?.dualChannel?.enabled;
}
